import {
  useFetchMixAPi1,
  useAPICmfToast,
  useFetchCmf,
  useMixApi1,
  useFetchMixAPi1Cmf,
  useFetchMxfNestApi,
} from "hooks";
import { useCallback } from "react";
import { getURLWithParams } from "utils/context";

// TODO: useRobotConfig
export const usePortaria = (params = {}) =>
  useFetchMixAPi1(getURLWithParams(`/legislacao/portaria`, params));

export const useControlClients = (params = {}) =>
  useFetchMixAPi1(getURLWithParams(`/cmf/clientes`, params));

export const useTiposContratos = (params = {}) =>
  useFetchMixAPi1(getURLWithParams(`/mxf/clientes/tipos-cadastros`, params));

export const useControlClientsLogs = ({ id }) =>
  useFetchMixAPi1(getURLWithParams(id ? `/cmf/cliente/${id}` : null));

export const useControlClientsLogsAgend = id =>
  useFetchMixAPi1Cmf(
    getURLWithParams(id ? `/panel/costumer/scheduling/${id}` : null),
  );

export const useControlErrorLogs = ({ id }) =>
  useFetchMixAPi1(getURLWithParams(id ? `/logs/log-error/${id}` : null));

export const useControlLogs = (id, params = {}) =>
  useFetchMixAPi1(
    getURLWithParams(id ? `/logs/cmf-processamento/logs/${id}` : null, params),
  );

export const useControlLogsDetail = (id, params = {}) =>
  useFetchMixAPi1(
    getURLWithParams(`/logs/cmf-processamento/logs/${id}`, params),
  );

export const UseHealthCheck = id =>
  useFetchMixAPi1(`/proxy/robot/health-check/${id}`);

export const useControlErrorLogsDetail = (id, params = {}) =>
  useFetchMixAPi1(getURLWithParams(id && `/logs/log-error/${id}`, params));

export const useControlErrorLogsDetailErrImportProd = (id, params = {}) =>
  useFetchMixAPi1(getURLWithParams(`/logs/importa-produto-erro/${id}`, params));

// TODO: Faltando enviar o cmfCliId
export const useActionCmfAgendadorCarga = () => {
  const toast = useAPICmfToast();

  return {
    isLoading: toast.isLoading,
    onCargaCongelamentoConfiguration: data =>
      toast.onSend({
        endpoint: "/cmf/update",
        messageSuccess: "Salva as configurações de congelamento",
        messageFail: "Falha ao tentar salvar as configurações de congelamento",
        data,
      }),
    onCargaCongelamentoProcess: data =>
      toast.onSend({
        endpoint: "/cmf/importar-congelados",
        messageSuccess: "Produtos congelados com sucesso",
        messageFail: "Falha ao tentar congelar os produtos",
        data,
      }),

    onCargaDescongelamentoProcess: data =>
      toast.onSend({
        endpoint: "/cmf/importar-descongelar",
        messageSuccess: "Produtos congelados com sucesso",
        messageFail: "Falha ao tentar congelar os produtos",
        data,
      }),
    onLoadQueimaCaixaRiscoAssumido: data =>
      toast.onSend({
        endpoint: "/cmf/importar-queima-risco",
        messageSuccess: "Queima caixa e risco assumido carregados com sucesso!",
        messageFail: "Não foi possível carregar Queima caixa e risco assumido!",
        data,
      }),
  };
};

export const useFecthProductsByStatusCmf = cmfId =>
  useFetchCmf(getURLWithParams("/cmf/totals-products-by-status", { cmfId }));

export const useFecthLogsGeral = (cmfId, types = "") =>
  useFetchCmf(getURLWithParams("/cmf/geral-logs", { cmfId, types }));

export const useClassificationSendProds = () => {
  const toast = useAPICmfToast();

  return {
    isLoading: toast.isLoading,
    onSendSimilarProds: data =>
      toast.onSend({
        endpoint: "/classificados-liberar-por-cliente",
        messageSuccess: "Produtos similares liberados com sucesso!",
        messageFail: "Não foi possível liberar os produtos similares.",
        data,
      }),
  };
};

export const useGetProdSimilarLog = id =>
  useFetchCmf(
    getURLWithParams("/classificados-liberar-por-cliente-logs-processos", id),
  );

export const useGetProdSimilarLogTotals = params =>
  useFetchCmf(
    getURLWithParams("/classificados-liberar-por-cliente-totals", params),
  );

export const useGetSimilarityProductsList = params =>
  useFetchCmf(
    getURLWithParams(
      "/classificados-liberar-por-cliente-similaridade-list",
      params,
    ),
  );

export const useCmfSchedulings = id =>
  useFetchMixAPi1Cmf(id && `/panel/costumer/scheduling/${id}`);

// params null desativa a requisição (padrão SWR) — usado pela paginação do QG.
export const useMovimentoClientes = (params = {}) =>
  useFetchMixAPi1(
    params ? getURLWithParams(`/movimento/movimento-clientes`, params) : null,
  );

// Verifica, assim que a tela carrega, se o cliente (por CNPJ) está ativo no
// Painel de Controle. Enquanto a checagem não resolve, assume acesso liberado
// para não travar/piscar a UI antes da resposta — as ações que dependem disso
// (reprocessar carga, agendamento) fazem sua própria checagem no momento do
// envio. Sem cnpj, não há o que checar: falha fechado (sem acesso) em vez de
// ficar otimista pra sempre, já que sem cnpj a requisição nunca dispara.
export const useHasPanelAccess = cnpj => {
  const { data, isLoading } = useMovimentoClientes(
    cnpj ? { cnpj, is_active: true, page: 1, limit: 1 } : null,
  );

  if (!cnpj) {
    return { hasPanelAccess: false, isLoading: false };
  }

  return {
    hasPanelAccess: isLoading || (data?.data?.length ?? 0) > 0,
    isLoading,
  };
};

export const useStatisticsMovimentoClientes = () =>
  useFetchMixAPi1(
    getURLWithParams(`/movimento/estatisticas-movimento-cliente`),
  );

export const useErroImportacaoProdutosClientes = (params = {}) =>
  useFetchMixAPi1(
    params.cmf_cli_id
      ? getURLWithParams("/movimento/erro-importacao-produtos-cliente", params)
      : null,
  );

export const useClientsList = (params = {}) =>
  useFetchMixAPi1(getURLWithParams(`/mxf/clientes`, params));

export const useClientsAsync = () => {
  const api = useMixApi1();

  const fetchClients = useCallback(
    async (params = {}) => {
      try {
        const response = await api.get(
          getURLWithParams("/mxf/clientes", params),
        );

        const data = response.data || [];
        return data;
      } catch (error) {
        console.error("Error fetching clients:", error);
        return [];
      }
    },
    [api],
  );
  return {
    fetchClients,
  };
};

// Respostas de cliente ainda não aprovadas (fila "A revisar" da Classificação),
// do mixfiscal-api-mxf. Contagem em lote pelos MXF IDs da página.
export const useContagemRespostasARevisar = (cliIds = []) =>
  useFetchMxfNestApi(
    cliIds.length
      ? getURLWithParams("/rever-descricao/respostas-a-revisar/contagem", {
          cli_ids: cliIds.join(","),
        })
      : null,
  );

export const useRespostasARevisar = cliId =>
  useFetchMxfNestApi(
    cliId
      ? getURLWithParams("/rever-descricao/respostas-a-revisar", {
          cli_id: cliId,
        })
      : null,
  );
